import React from "react";

export default function Close(props) {
	const color = props.color || "#f9f9f9";
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="15.207" height="13.514">
			<g data-name="Group 458" fill="none" stroke={color} strokeWidth="2">
				<path data-name="Line 105" d="m.653.757 13.9 12" />
				<path data-name="Line 106" d="m.653 12.757 13.9-12" />
			</g>
		</svg>
	);
}
